<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'attach-document.associate-documentation-files'">_Asociar archivos de la documentación</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-list-simple [field]="attachDocumentModal.conceptDocument"
        [listValues]="attachDocumentModal.conceptDocumentList"
        (itemSelected)="itemSelected($event, 'associatedDocuments')">
      </field-type-list-simple>
      <field-type-text-multiline [field]="attachDocumentModal.addCommentField"
        [preSelectItem]="attachDocumentModal.comments"
        (itemSelected)="attachDocumentModal.comments = $event.newValue">
      </field-type-text-multiline>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="associateDocuments()">
      <span class="common-button__text-title"
        [afTranslate]="'common.associate'">_Asociar</span>
    </button>
  </div>
</div>
